module.exports = __webpack_public_path__ + "img/delete.952ce427.svg";